var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mvpList && _vm.mvpList.length > 0
    ? _c("div", { staticClass: "round-mvp" }, [
        _c("div", { staticClass: "mvp-header" }, [
          _c("img", {
            staticClass: "header-icon",
            attrs: {
              loading: "lazy",
              fetchpriority: "low",
              src: require("../../assets/mvpIcon.svg"),
            },
          }),
          _c("span", { staticClass: "header-title" }, [_vm._v("ROUND MVP")]),
        ]),
        _c(
          "div",
          { staticClass: "mvp-list" },
          _vm._l(_vm.mvpList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "mvp-item animate-drop",
                class: {
                  "is-featured":
                    _vm.mvpCount === 1 ||
                    _vm.mvpCount === 2 ||
                    (_vm.mvpCount > 2 && index === 1),
                },
                style: _vm.getAnimationStyle(index, _vm.mvpCount),
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-inner colors-animation",
                    class: {
                      "style-silver": _vm.mvpCount > 2 && index === 0,
                      "style-gold":
                        _vm.mvpCount === 1 ||
                        _vm.mvpCount === 2 ||
                        (_vm.mvpCount > 2 && index === 1),
                      "style-bronze": _vm.mvpCount > 2 && index === 2,
                    },
                  },
                  [
                    _c("div", { staticClass: "bg-lines" }),
                    _c("div", { staticClass: "user-wrapper" }, [
                      _c("div", { staticClass: "avatar-box" }, [
                        _c("img", {
                          staticClass: "avatar-img",
                          attrs: {
                            src: _vm.getUserAvatar(item),
                            alt: "avatar",
                          },
                        }),
                        _c("div", { staticClass: "multiplier-badge" }, [
                          _c("span", { staticClass: "multiplier-text" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatMultiplier(item.stoppedAt)) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("span", { staticClass: "item-name" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getItemName(item.rewardItem)) + " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "item-image-wrapper",
                        class:
                          _vm.mvpCount === 3 && index !== 1
                            ? "is-small"
                            : "is-large",
                      },
                      [
                        _c("img", {
                          staticClass: "item-img",
                          attrs: {
                            src: _vm.getItemImage(item.rewardItem),
                            alt: "",
                          },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "win-badge" }, [
                      _c("i", { staticClass: "icon icon_coin-bold coin-icon" }),
                      _c("span", { staticClass: "win-text" }, [
                        _vm._v(" " + _vm._s(item.winningAmount) + " "),
                      ]),
                    ]),
                    _c("img", {
                      staticClass: "bg-mask",
                      class:
                        _vm.mvpCount === 2 || (_vm.mvpCount > 2 && index === 1)
                          ? "mask-large"
                          : "mask-small",
                      attrs: { loading: "lazy", fetchpriority: "low" },
                    }),
                  ]
                ),
                _c("img", {
                  staticClass: "star-icon",
                  attrs: {
                    loading: "lazy",
                    fetchpriority: "low",
                    src: _vm.mvpStarSrc(index),
                  },
                }),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }